var widget_default = {
  "card": "LlO6b",
  "link": "fqFYH",
  "container": "o6Ijx",
  "image": "_0ykHv",
  "right": "-zfWU",
  "cardLayout": "Xhmku",
  "content": "PDcCw",
  "title": "apFFR",
  "subtitle": "VRB9B",
  "button": "F-1-F",
  "button_disabled": "nuOH0",
  "buttonText": "IwNXs",
  "slimLayout": "cHwAG",
  "contentText": "CVk1r"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
